// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyTwoToneSvg from "@ant-design/icons-svg/es/asn/CopyTwoTone";
import AntdIcon from '../components/AntdIcon';

var CopyTwoTone = function CopyTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyTwoToneSvg
  }));
};

CopyTwoTone.displayName = 'CopyTwoTone';
export default React.forwardRef(CopyTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CopyTwoTone.js
// module id = 873
// module chunks = 0